"use strict";

var _objectWithoutProperties = require("/root/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _components = require("./components");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes.string,
  size: _propTypes.string,
  weight: _propTypes.string,
  'data-testid': _propTypes.string,
  children: _propTypes.node
} : {};
var defaultProps = {
  color: 'colorFontNeutral90',
  size: 'xs',
  weight: 'lg',
  'data-testid': 'tag'
};

var Tag = function Tag(_ref) {
  var children = _ref.children,
      size = _ref.size,
      color = _ref.color,
      weight = _ref.weight,
      dataTestId = _ref['data-testid'],
      others = _objectWithoutProperties(_ref, ["children", "size", "color", "weight", "data-testid"]);

  return (0, _core.jsx)(_components.Tag, (0, _extends2.default)({
    "data-testid": dataTestId,
    tagColor: color,
    mobile: size,
    desktop: size,
    weight: weight
  }, others), children);
};

exports.Tag = Tag;
process.env.NODE_ENV !== "production" ? Tag.propTypes = propTypes : void 0;
Tag.defaultProps = defaultProps;